import type React from 'react';
import { Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { DebtPaymentRequest } from '@/types/manager.model';
import { currencyFormatter } from '@/utils/movements-utils';

interface PendingTransfersBannerProps {
  pending: DebtPaymentRequest[];
  onView: () => void;
}

const PendingTransfersBanner: React.FC<PendingTransfersBannerProps> = ({
  pending,
  onView,
}) => {
  if (pending.length === 0) return null;

  const count = pending.length;
  const total = pending.reduce((sum, req) => sum + Number(req.amount ?? 0), 0);
  const plural = count === 1 ? 'transferencia' : 'transferencias';

  return (
    <div className="mt-6 flex flex-col gap-3 rounded-[10px] border border-[#B8CDFB] border-l-4 border-l-[#1E40AF] bg-white p-4 sm:flex-row sm:items-center">
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-[#E5EEFF] text-[#1E40AF]">
        <Clock className="h-5 w-5" />
      </span>
      <div className="flex-1">
        <p className="text-sm text-[#1F2937]">
          Tenés {count} {plural} en revisión por{' '}
          <strong>{currencyFormatter.format(total)}</strong>
        </p>
        <p className="text-[13px] text-[#6B7280]">
          Cuando aprobemos, descontamos del saldo negativo automáticamente.
        </p>
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={onView}
        className="w-full sm:w-auto"
      >
        {count === 1 ? 'Ver solicitud' : 'Ver solicitudes'}
      </Button>
    </div>
  );
};

export default PendingTransfersBanner;
